export default {
  voiceTalkMode(state: any): any {
    return state.mode;
  },
  voiceTalkSessionId(state: any): any {
    return state.sessionId;
  },
  voiceTalkRoomNumber(state: any): any {
    return state.roomNumber;
  },
};
